import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { TallyCompany } from '../../../../types/tally';

interface ConfirmFetchDialogProps {
  open: boolean;
  selectedCompany: TallyCompany | null;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmFetchDialog: React.FC<ConfirmFetchDialogProps> = ({
  open,
  selectedCompany,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description">
      <DialogTitle id="confirm-dialog-title">
        Confirm Company Activation
      </DialogTitle>
      <DialogContent id="confirm-dialog-description">
        <Typography>
          Please ensure that <strong>{selectedCompany?.name}</strong> is the
          currently active company in Tally.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          Do you want to proceed with fetching its details?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} autoFocus>
          Confirm and Fetch
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmFetchDialog;
